import React, { Component } from "react";
// import { connect } from "react-redux";
// import { Field, reduxForm, formValueSelector } from "redux-form";
import "./Login.css";
// import "src/styles/style.less"
// import 'src/styles/style.less';
// import { Form, Field } from 'react-final-form'

// import { createStore, combineReducers } from 'redux'
// import { reducer as formReducer } from 'redux-form'
import logo from "../../../img/farmakom_branding.webp";
import { connect } from "react-redux";
import { login, getAgent } from "../../../reducers/modules/Login";

import data from "bootstrap/js/src/dom/data";
import { isMobile } from "react-device-detect";

// const logData = {
//   username: "teo",
//   password: "teo",
// };

class Login extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    email: "",
    password: "",
    error: false,
  };
  componentDidMount = async () => {
    if (localStorage.getItem("token")) {
      const response = await this.props.getAgent(localStorage.getItem("token"));
      if (response.data) {
        this.props.history.push("/Dispatcher");
      }
    }
  };

  handleSubmit = async () => {
    // console.log("submitted");
    const dataLogin = {
      email: this.state.email,
      password: this.state.password,
    };

    const res = await login(dataLogin);

    if (res.status === 200) {
      this.props.history.push("/Dispatcher");
    } else {
      this.setState({ error: true });
    }
  };

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    // console.log("state",this.state)
    return (
      <div className="login container-fluid">
        <img src={logo} alt={"Logo"} className="img" />
        {/* <form onSubmit={this.handleSubmit}> */}
        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                // component="input"
                type="text"
                className="form-control"
                placeholder={"Email"}
                value={this.state.email}
                onChange={this.handleChange}
                style={{ minWidth: isMobile ? "64vw" : "unset" }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                name="password"
                // component="input"
                type="password"
                placeholder={"Password"}
                value={this.state.password}
                className="form-control"
                onChange={this.handleChange}
                style={{ minWidth: isMobile ? "64vw" : "unset" }}
              />
            </div>
            <div style={{ marginTop: 16 }} className="error-login">
              {this.state.error && "Username o password errate"}
            </div>
            <div className="login-button">
              <button
                type="button"
                onClick={this.handleSubmit}
                className="btn btn-primary"
                style={{
                  backgroundColor: "#39fbc7",
                  border: "none",
                  marginTop: 24,
                  padding: "8px 24px",
                }}
              >
                Login
              </button>
            </div>
          </div>
        </div>
        {/* </form> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { login, getAgent })(Login);
